// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBsE03bSfRUb0on-p3IOLb2_mHNSHp6DKw",
  authDomain: "jumiaclone-87d8e.firebaseapp.com",
  projectId: "jumiaclone-87d8e",
  storageBucket: "jumiaclone-87d8e.appspot.com",
  messagingSenderId: "90948827795",
  appId: "1:90948827795:web:ac999f3f1615c81bafab66",
  measurementId: "G-EY0LM89VH2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// const analytics = getAnalytics(app);
export {auth};